import { toComparableText } from '@/utils/textValue';

const FILTER_KEYS = ['class', 'category', 'specialty', 'area'];

export const createDefaultSupplierFilters = () => ({
  class: [],
  category: [],
  specialty: [],
  area: [],
});

export const normalizeSupplierFilters = (filters) => {
  const normalized = filters && typeof filters === 'object' ? filters : {};

  const next = {
    ...createDefaultSupplierFilters(),
    ...normalized,
  };

  FILTER_KEYS.forEach((key) => {
    next[key] = Array.isArray(next[key]) ? next[key] : [];
  });

  return next;
};

export const buildSuppliersListParams = ({
  filters,
}) => {
  const normalizedFilters = normalizeSupplierFilters(filters);

  return {
    class: normalizedFilters.class,
    category: normalizedFilters.category,
    specialty: normalizedFilters.specialty,
    area: normalizedFilters.area,
  };
};

export const buildSuppliersMetricsParams = (filters) => {
  const normalizedFilters = normalizeSupplierFilters(filters);

  return {
    class: normalizedFilters.class,
    category: normalizedFilters.category,
    specialty: normalizedFilters.specialty,
    area: normalizedFilters.area,
  };
};

export const matchesSuppliersSearch = (row, searchTerm) => {
  const search = toComparableText(searchTerm);
  if (!search) {
    return true;
  }

  const haystack = [
    row?.name,
    row?.email,
    row?.main_contact_name,
    row?.main_contact?.name,
    row?.class_name,
    row?.category_name,
    row?.specialty_name,
  ]
    .map((value) => toComparableText(value))
    .join(' ');

  return haystack.includes(search);
};

export const filterSuppliersRowsLocal = (rows, searchTerm) => {
  const sourceRows = Array.isArray(rows) ? rows : [];

  return sourceRows.filter((row) => {
    return matchesSuppliersSearch(row, searchTerm);
  });
};
